import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-list-details',
  templateUrl: './psa-list-details.component.html',
  styleUrls: ['./psa-list-details.component.css']
})
export class PsaListDetailsComponent implements OnInit {
 title="List of Private Security Agency";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/main/psa-list-details/psa-list-details.component.ts